<div class="space-y-6">
  <app-page-header
    title="Locations"
    subtitle="Toutes les réservations de la plateforme — statut, dates, montant."
  />

  <section class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="border-b border-gray-200 px-5 py-4 dark:border-gray-800">
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:flex-1">
          <div class="relative max-w-md flex-1">
            <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5 text-gray-400">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.04199 9.37381C3.04199 5.87712 5.87711 3.04199 9.3738 3.04199C12.8705 3.04199 15.7056 5.87712 15.7056 9.37381C15.7056 10.9354 15.1399 12.3646 14.2024 13.4685L16.5979 15.8638C16.8908 16.1567 16.8908 16.6315 16.5979 16.9244C16.305 17.2173 15.8302 17.2173 15.5373 16.9244L13.1422 14.529C12.0381 15.4674 10.6083 16.0337 9.3738 16.0337C5.87711 16.0337 3.04199 13.1985 3.04199 9.37381ZM9.3738 4.54199C6.70557 4.54199 4.54199 6.70557 4.54199 9.37381C4.54199 12.0421 6.70557 14.2056 9.3738 14.2056C12.042 14.2056 14.2056 12.0421 14.2056 9.37381C14.2056 6.70557 12.042 4.54199 9.3738 4.54199Z" fill="currentColor" />
              </svg>
            </span>
            <input
              type="text"
              placeholder="Plaque, marque, lieu…"
              [formControl]="searchCtrl"
              class="h-11 w-full rounded-lg border border-gray-300 bg-transparent pl-11 pr-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
            />
          </div>
          <div class="w-48">
            <app-pretty-select
              [formControl]="statusCtrl"
              [options]="statusOptions"
              placeholder="Tous statuts"
              clearable
            />
          </div>
        </div>
        <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
          <span>Par page</span>
          <div class="w-20">
            <app-pretty-select
              [options]="pageSizeOptions"
              [ngModel]="size()"
              (ngModelChange)="changeSize($event ?? 10)"
              placeholder="10"
            />
          </div>
        </div>
      </div>
    </div>

    @if (error() || (loading() && rentals().length === 0) || rentals().length === 0) {
      <app-data-state
        [loading]="loading()"
        [error]="error()"
        [empty]="!loading() && !error() && rentals().length === 0"
        loadingMessage="Chargement des locations…"
        emptyMessage="Aucune location ne correspond aux critères."
        (retry)="load()"
      />
    } @else {
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-800">
          <thead class="bg-gray-50 dark:bg-white/[0.02]">
            <tr>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Véhicule</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Client</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Période</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Statut</th>
              <th class="px-5 py-3 text-right text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Montant</th>
              <th class="px-5 py-3 text-right text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white dark:divide-gray-800 dark:bg-transparent">
            @for (r of rentals(); track r.id) {
              <tr class="transition hover:bg-gray-50 dark:hover:bg-white/[0.02]">
                <td class="whitespace-nowrap px-5 py-4">
                  <div class="flex items-center gap-3">
                    @if (r.vehicle?.imgCover) {
                      <img [src]="r.vehicle?.imgCover" [alt]="r._vehicleName" class="h-12 w-16 rounded-md object-cover" />
                    } @else {
                      <span class="flex h-12 w-16 items-center justify-center rounded-md bg-gray-100 text-gray-400 dark:bg-gray-800">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M6.5 5.75A1.25 1.25 0 0 0 5.3 6.62l-1.05 3.13H3.75a.75.75 0 0 0-.75.75V14a.75.75 0 0 0 .75.75H4.5v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h10v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h.75A.75.75 0 0 0 21 14v-3.5a.75.75 0 0 0-.75-.75h-.5L18.7 6.62A1.25 1.25 0 0 0 17.5 5.75h-11Z"/></svg>
                      </span>
                    }
                    <div class="min-w-0">
                      <p class="truncate text-sm font-medium text-gray-800 dark:text-white/90">{{ r._vehicleName }}</p>
                      <p class="truncate font-mono text-xs text-gray-500 dark:text-gray-400">{{ r._vehicleSubtitle }}</p>
                    </div>
                  </div>
                </td>
                <td class="whitespace-nowrap px-5 py-4">
                  @if (r.customer; as c) {
                    <app-user-cell [user]="c.user" [fallbackId]="c.userId" />
                    @if (c.licenseNumber) {
                      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Permis {{ c.licenseNumber }}</p>
                    }
                  } @else if (r.userId) {
                    <app-user-cell [fallbackId]="r.userId" />
                  } @else {
                    <span class="text-xs text-gray-400">—</span>
                  }
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                  <div class="space-y-0.5">
                    <p>{{ r.startDate | ldate:'dd/MM/yy HH:mm' }}</p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">→ {{ r.endDate | ldate:'dd/MM/yy HH:mm' }}</p>
                  </div>
                </td>
                <td class="whitespace-nowrap px-5 py-4">
                  <span
                    class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
                    [class.bg-brand-50]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                    [class.text-brand-700]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                    [class.dark:bg-brand-500/15]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                    [class.dark:text-brand-400]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                    [class.bg-blue-light-50]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                    [class.text-blue-light-700]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                    [class.dark:bg-blue-light-500/15]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                    [class.dark:text-blue-light-400]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                    [class.bg-warning-50]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                    [class.text-warning-700]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                    [class.dark:bg-warning-500/15]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                    [class.dark:text-warning-400]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                    [class.bg-gray-100]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                    [class.text-gray-700]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                    [class.dark:bg-gray-800]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                    [class.dark:text-gray-300]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                    [class.bg-error-50]="statusMeta[r.rentalStatusEnum].palette === 'error'"
                    [class.text-error-700]="statusMeta[r.rentalStatusEnum].palette === 'error'"
                    [class.dark:bg-error-500/15]="statusMeta[r.rentalStatusEnum].palette === 'error'"
                    [class.dark:text-error-400]="statusMeta[r.rentalStatusEnum].palette === 'error'"
                  >
                    {{ statusMeta[r.rentalStatusEnum].label }}
                  </span>
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-right text-sm text-gray-700 dark:text-gray-300">
                  {{ r.totalCost | number:'1.0-0' }} <span class="text-xs text-gray-400">XOF</span>
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-right">
                  <a [routerLink]="['/rentals', r.id]" class="text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">Voir</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (totalPages() > 0) {
        <div class="flex flex-col gap-3 border-t border-gray-200 px-5 py-4 dark:border-gray-800 sm:flex-row sm:items-center sm:justify-between">
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Page {{ page() }} sur {{ totalPages() }} — {{ totalItems() }} location(s)
          </p>
          <div class="flex flex-wrap items-center gap-1">
            <button type="button" (click)="goToPage(page() - 1)" [disabled]="page() <= 1" class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/5">Précédent</button>
            @for (n of pageWindow(); track n) {
              <button
                type="button"
                (click)="goToPage(n)"
                class="min-w-[36px] rounded-lg border px-3 py-1.5 text-xs font-medium transition"
                [class.border-brand-500]="n === page()"
                [class.bg-brand-500]="n === page()"
                [class.text-white]="n === page()"
                [class.border-gray-300]="n !== page()"
                [class.text-gray-700]="n !== page()"
                [class.hover:bg-gray-50]="n !== page()"
                [class.dark:border-gray-700]="n !== page()"
                [class.dark:text-gray-400]="n !== page()"
                [class.dark:hover:bg-white/5]="n !== page()"
              >
                {{ n }}
              </button>
            }
            <button type="button" (click)="goToPage(page() + 1)" [disabled]="page() >= totalPages()" class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/5">Suivant</button>
          </div>
        </div>
      }
    }
  </section>
</div>
